import script from "./HelpView.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpView.vue?vue&type=script&setup=true&lang=js"

import "./HelpView.vue?vue&type=style&index=0&id=6a2adc22&lang=scss"

const __exports__ = script;

export default __exports__